<!--Componente para los SubAgentes. Donde cada subAgente realiza pedidos a su distribuidor. Puede ver los pedidos realizados -->
<template>
  <div :data-testid="TEST_ID.PEDIDOS_DISTRIBUIDOR.ROOT">
    <el-row class="container" style="margin-top:15px;" :gutter="20">
      <!-- Columna Filtros -->
      <el-col class="container_col_1" :span="6">
       <el-row style="margin-bottom:15px;">
          <el-col :span="16">
            <div class="title" :data-testid="TEST_ID.PEDIDOS_COMMON.FILTERS_TITLE">{{ $t('NAVBAR_pedidosDistribuidores') }}</div>
          </el-col>
          <el-col :span="8" class="btn-nuevo">
            <router-link class="btn-nuevo" :to="{ name: 'Alta Pedido a Distribuidor'}">
              <el-button type="primary" icon="Plus" size="small" round :data-testid="TEST_ID.PEDIDOS_COMMON.NEW_BUTTON">{{ $t('GENERAL_nuevo') }}</el-button>
            </router-link>
          </el-col>
        </el-row>

        <!-- Busqueda simple -->
        <el-row>
          <el-collapse v-model="activeNames" style="margin-bottom: 5px;">
            <el-collapse-item class="busqueda" :title="$t('GENERAL_Busqueda_Simple')" name="1">
              <template #title>
                <span :data-testid="TEST_ID.PEDIDOS_COMMON.SEARCH_COLLAPSE_HEADER">{{ $t('GENERAL_Busqueda_Simple') }}</span>
              </template>
              <div class="filters" :data-testid="TEST_ID.PEDIDOS_COMMON.SEARCH_COLLAPSE_BODY"> 

                <div class="filters_item">
                  <div class="label" :data-testid="TEST_ID.PEDIDOS_COMMON.FILTER_INSTANCIA_LABEL">{{$t('PEDIDO_instancia')}}</div>
                    <el-select 
                      class="seleccionador" 
                      v-model="filtros.instancia" 
                      size="small" 
                      @change="getPedidosDelayed"
                      :placeholder="$t('PEDIDOADISTRIBUIDORES_instancia_sin_confirmar')"
                      :data-testid="TEST_ID.PEDIDOS_COMMON.FILTER_INSTANCIA_SELECT"
                    >
                      <el-option :value='""' :label="$t('GENERAL_OPCION_TODOS')" :data-testid="TEST_ID.PEDIDOS_COMMON.FILTER_INSTANCIA_OPTION_ALL"></el-option>
                      <el-option :value="'1'" :label="$t('PEDIDOADISTRIBUIDORES_instancia_ingreso')" :data-testid="TEST_ID.PEDIDOS_DISTRIBUIDOR.INSTANCE_OPTION_INGRESO"></el-option>
                      <el-option :value="'4'" :label="$t('PEDIDOADISTRIBUIDORES_instancia_confirmado')" :data-testid="TEST_ID.PEDIDOS_DISTRIBUIDOR.INSTANCE_OPTION_CONFIRMADO"></el-option>
                      <el-option :value="'3'" :label="$t('PEDIDOADISTRIBUIDORES_instancia_seleccionado')" :data-testid="TEST_ID.PEDIDOS_DISTRIBUIDOR.INSTANCE_OPTION_SELECCIONADO"></el-option>
                      <el-option :value="'2'" :label="$t('PEDIDOADISTRIBUIDORES_instancia_historico')" :data-testid="TEST_ID.PEDIDOS_DISTRIBUIDOR.INSTANCE_OPTION_HISTORICO"></el-option>
                  </el-select>
                </div>

                <div class="filters_item">
                  <div class="label">{{ $t('PEDIDO_numero') }}</div>
                  <el-input
                    :placeholder="$t('PEDIDO_numero_placeholder')"
                    size="small"
                    v-model="filtros.numero"
                    @input="getPedidosDelayed"
                    :data-testid="TEST_ID.PEDIDOS_COMMON.FILTER_NUMERO_INPUT"
                  />
                </div>
              

              <div v-show="!showDateOptions">
                  <div class="filters_item">
                  <el-row style="text-align:left;">
                    <el-col :span="2">
                      <el-checkbox                                       
                        v-model="filtros.checkPeriodo"
                        size="default"
                        @change="changeCheck('P')"
                        :data-testid="TEST_ID.PEDIDOS_COMMON.FILTER_PERIODO_CHECKBOX"
                        >
                      </el-checkbox>
                    </el-col>

                    <el-col :span="20" style="text-align:left !important;">
                      <el-dropdown trigger="click" @command="changePeriodo">
                        <span
                          :class="{'el-dropdown-link': filtros.checkPeriodo, 'el-dropdown-link-active': !filtros.checkPeriodo}"
                          :data-testid="TEST_ID.PEDIDOS_COMMON.FILTER_PERIODO_DROPDOWN_TRIGGER"
                        >
                          {{this.$t(filtros.periodo)}}
                          <el-icon><ArrowDown /></el-icon>
                        </span>
                        <template #dropdown>
                          <el-dropdown-menu>
                            <el-dropdown-item command="PEDIDO_periodo_meses_1" :disabled="filtros.checkRango" :data-testid="TEST_ID.PEDIDOS_COMMON.FILTER_PERIODO_OPTION_1">{{$t('PEDIDO_periodo_meses_1')}}</el-dropdown-item>
                            <el-dropdown-item command="PEDIDO_periodo_meses_2" :disabled="filtros.checkRango" :data-testid="TEST_ID.PEDIDOS_COMMON.FILTER_PERIODO_OPTION_2">{{$t('PEDIDO_periodo_meses_2')}}</el-dropdown-item>
                            <el-dropdown-item command="PEDIDO_periodo_meses_3" :disabled="filtros.checkRango" :data-testid="TEST_ID.PEDIDOS_COMMON.FILTER_PERIODO_OPTION_3">{{$t('PEDIDO_periodo_meses_3')}}</el-dropdown-item>
                            <el-dropdown-item command="PEDIDO_periodo_ultimos_2anios" :disabled="filtros.checkRango" :data-testid="TEST_ID.PEDIDOS_COMMON.FILTER_PERIODO_OPTION_4">{{$t('PEDIDO_periodo_ultimos_2anios')}}</el-dropdown-item>
                          </el-dropdown-menu>
                        </template>
                      </el-dropdown>
                    </el-col>
                  </el-row>
                </div>

                <div class="filters_item">
                  <el-row style="text-align:left; vertical-align:top;">
                    <el-col :span="2">
                      <el-checkbox
                        v-model="filtros.checkRango"
                        size="default"
                        @change="changeCheck('R')"
                        :data-testid="TEST_ID.PEDIDOS_COMMON.FILTER_RANGO_CHECKBOX"
                        >              
                      </el-checkbox>
                    </el-col>
                    <el-col :span="20">
                      <div class="label" style="padding-top:3px !important;" :data-testid="TEST_ID.PEDIDOS_COMMON.FILTER_DATE_DESDE_LABEL">{{$t('GENERAL_desde')}}</div>
                      <div :data-testid="TEST_ID.PEDIDOS_COMMON.FILTER_DATE_DESDE_INPUT">
                        <el-date-picker
                          style="width:90%"
                          v-model="filtros.from"
                          type="date"
                          size="small"
                          format="DD/MM/YYYY"
                          suffix-icon="Calendar"
                          placeholder="dd/mm/aaaa"
                          @input="getPedidosDelayed"
                          @change="getPedidosDelayed"
                          :picker-options="pickerOptionsFrom"
                          :disabled="filtros.checkPeriodo"
                        />
                      </div>

                      <div class="label" :data-testid="TEST_ID.PEDIDOS_COMMON.FILTER_DATE_HASTA_LABEL">{{$t('GENERAL_hasta')}}</div>
                      <div :data-testid="TEST_ID.PEDIDOS_COMMON.FILTER_DATE_HASTA_INPUT">
                        <el-date-picker
                          v-model="filtros.to"
                          style="width:90%"
                          type="date"
                          size="small"
                          format="DD/MM/YYYY"
                          suffix-icon="Calendar"
                          placeholder="dd/mm/aaaa"
                          @input="getPedidosDelayed"
                          @change="getPedidosDelayed"
                          :picker-options="pickerOptionsTo"
                          :disabled="filtros.checkPeriodo"
                        />
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </div>

              <div class="clearFilters" @click="cleanFilters" :data-testid="TEST_ID.PEDIDOS_COMMON.CLEAR_FILTERS_BUTTON">{{$t('GENERAL_clean_filters')}}</div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </el-row>
      </el-col>

      <!-- Resultados de b�squeda --> 
      <el-col class="container_col_2" :span="17">
        <!-- Header resultados de b�squeda -->
        <el-row style="margin-bottom:3px;">
          <el-col :xs="8" :sm="12"  :md="10" :lg="16" :xl="16">
             <div class="sub-title">{{$t('GENERAL_resultado')}}</div>
          </el-col>
          <el-col :xs="16" :sm="12"  :md="14" :lg="8" :xl="8" class="pagination_container">
            <el-pagination         
              background
              size="small"
              layout="prev, pager, next"
              :current-page="paginador.page"
              :page-count="paginador.nro_pages"
              :page-size="paginador.pageSize"
              @current-change="handlePageChange"
              hide-on-single-page
              :pager-count="5"
            ></el-pagination>
          </el-col>
        </el-row>
        <el-row style="text-align: left;" class="SinConfirmar">
          {{$t('PEDIDO_sin_confirmar')}}: {{ pedidosSinConfirmar }}
        </el-row>

        <!-- Pedidos -->
        <div>
            <div class="card_list" :data-testid="TEST_ID.PEDIDOS_COMMON.CARD_LIST">
            <div v-if="loading" v-loading.lock="loading" class="loader"></div>
            <div v-else-if="pedidos !== undefined && pedidos.length > 0" class="card_list_item" v-for="pedido in pedidos" :key="pedido.Id" :data-testid="TEST_ID.PEDIDOS_COMMON.CARD_ITEM">
              <PedidoCard 
                :pedido="pedido" 
                :pantallaOrigen="pantallaOrigen"
                :verPrecios="verPreciosDistribuidor"
                @editar="editarPedido"
                @detalle="detallePedido"
                @eliminar="eliminarPedido"
              />
            </div>
            <div v-else class="loader">{{$t('GENERAL_no_data')}}</div>
          </div>
        </div>

        <!-- Paginador abajo -->
        <el-row style="margin-top:10px;">
          <el-col :xs="8" :sm="12" :md="10" :lg="16" :xl="16"></el-col>
          <el-col :xs="16" :sm="12" :md="14" :lg="8" :xl="8" class="pagination_container">
            <el-pagination
              background
              size="small"
              layout="prev, pager, next"
              :current-page="paginador.page"
              :page-count="paginador.nro_pages"
              :page-size="paginador.pageSize"
              @current-change="handlePageChange"
              hide-on-single-page
              :pager-count="5"
            ></el-pagination>
          </el-col>
        </el-row>
      </el-col>
    </el-row>

    <AppDialog 
      :visible="eliminar_pedido"
      :title="$t('PEDIDO_eliminar')"
      :message="eliminar_pedido_msg"
      :onClose="onCloseEliminarConfirmation"
    />
  </div>
</template>

<script>
  import PedidoCard from "@/components/Cards/pedidoCard";
  import { mapState } from "vuex";
  import AppDialog from "../Dialog";
  import { showSuccess } from "../Mensaje";
  import { mostrarMensajeInternacionalizado } from "../MensajeInternacionalizado";
  import { tienePermiso } from "@/security/autorizador";
  import { targets } from "@/security/target";
  import TEST_ID from "@/testIds.json";

  let defaultPaginador = {
    page: 1,
    nro_pages: 1,
    pageSize: 20
  };

  let defaultFilters = {
      instancia: '1',
      numero: "",
      from: undefined,
      to: undefined,
      periodo: "PEDIDO_periodo_meses_1",
      tipo_filtro: "PEDIDO_periodo",
      ordenar: "",
      checkPeriodo: true,
      checkRango: false
  };

    export default {
        name: "PedidosADistribuidores",
        components: { PedidoCard, AppDialog},

        data() {
      return {
        TEST_ID,
        pedido: undefined,
        pedidos: [],
        paginador: { ...defaultPaginador },
        filtros: { ...defaultFilters },
        activeNames: ["1"],
        loading: false,
        opened: false,
        pickerOptionsFrom: {
          disabledDate: this.disabledDateFrom
        },
        pickerOptionsTo: {
          disabledDate: this.disabledDateTo
        },
        pedidosSinConfirmar: 0,
        eliminar_pedido_msg: "",
        eliminar_pedido: false,
        pedido_id: undefined,

        pantallaOrigen: 'PedidoADistribuidor'
      };
    },
    computed: {
      ...mapState({
        idUsuario: state => state.sesion.resultadoAutenticacion.IdUsuario,
        ultimoFiltroAplicado: state => state.pedidosADistribuidores.filtrosPedido
      }),
      showDateOptions: function(){
        if(this.filtros.instancia == '1'){
          return true;
        }else{
          return false;
        }
      },
      verPreciosDistribuidor() {
        return tienePermiso(targets.PedidoADistribuidor_VerPrecios);
      }
    },
    methods: {

      changeCheck(check)
      {
        if(check =='P')
        {
          this.filtros.checkRango = this.filtros.checkPeriodo == true? false : true;
          this.filtros.tipo_filtro = "PEDIDO_periodo";
        }
        else
        { 
          this.filtros.checkPeriodo =this.filtros.checkRango == true? false:true;
          this.filtros.tipo_filtro = "PEDIDO_rango";
        }

        this.getPedidos()
      },

      disabledDateFrom(time) 
      {
        if (this.filtros.to !== "") 
          return time.getTime() > this.filtros.to;
        
        else 
          return false;
      },

      disabledDateTo(time) 
      {
        if (this.filtros.from !== "") 
          return time.getTime() < this.filtros.from;
        
        else 
          return false;
      },

      handlePageChange(page) 
      {
        this.paginador.page = page;
        this.getPedidos();
      },

      getPedidos() 
      {
        
        // armo el payload
        let payload = { }
        payload.idUsuario = this.idUsuario
        payload.instancia = this.filtros.instancia
        payload.numero = this.filtros.numero

        if (this.filtros.tipo_filtro !== "PEDIDO_periodo") 
        {
          if(payload.instancia == '1'){
            payload.desde = null;
            payload.hasta = null;
          }else{
            payload.desde = this.filtros.from;
            payload.hasta = this.filtros.to;

            if(!payload.desde && !payload.hasta)
              return
          }
          
        } 
        else 
        {
          payload.mesesADesfazar = this.mapPeriodoToMeses();
        }

        payload.page = this.paginador.page
        payload.pageSize = this.paginador.pageSize


        // indico que se est�n buscando los pedidos
        this.loading = true;

        // guardo los filtros aplicados
        this.$store.dispatch('pedidosADistribuidores/setFiltrosPedido', { ...this.filtros })
        //this.$store.dispatch('pedidos/setFiltrosPedido', { ...this.filtros })
        // busco los pedidos
        this.$store.dispatch('pedidosADistribuidores/getPedidos', payload)
        //this.$store.dispatch('pedidos/getPedidos', payload)
        .then(data => 
        {
          if(data.CodigoResultado == 0) 
          {
            var paginado = JSON.parse(data.Datos)
            this.pedidos = paginado.Result;
            this.paginador.nro_pages = paginado.TotalPages;


            //console.log(paginado);

            if(payload.instancia == '1'){
              this.pedidosSinConfirmar = paginado.TotalObjects;
            }

          }
        })
        .finally(() => {
          this.loading = false;
        })
      },

      getPedidosDelayed() 
      {
        if (this.timer) {
          clearTimeout(this.timer);
          this.timer = null;
        }

        this.timer = setTimeout(() => {
          this.paginador = { ...defaultPaginador };
          this.getPedidos();
        }, 1000);
      },

      changePeriodo(periodo) 
      {
        
        this.filtros.periodo = periodo;
        this.getPedidos();
      },

      cleanFilters() 
      {
        // limpio los filtros
        this.filtros = { ...defaultFilters };
        this.paginador = { ...defaultPaginador };

        // limpio los resultados de pedidos
        this.pedidos = [];

        this.getPedidos();
      },

      toggleOpen() 
      {
        this.opened = !this.opened      
      },

      mapPeriodoToMeses() 
      {
        if(this.filtros.instancia == '1'){
          return null;
        }else{
          switch (this.filtros.periodo) 
          {
            case "PEDIDO_periodo_meses_1":
              return -1;
            case "PEDIDO_periodo_meses_2":
              return -2;
            case "PEDIDO_periodo_meses_3":
              return -3;
            case "PEDIDO_periodo_ultimos_2anios":
              return -24;
            default:
              return 1;
          }
      }

      },

      editarPedido(id)
      {
        // this.$router.push({ path: `/pedidos/edicion/${id}`});
        this.$router.push({ name: 'Edicion Pedido a Distribuidor', params: {id}});
      },

      detallePedido(id)
      {
        // this.$router.push({ path: `/pedidos/detalle/${id}`});
        this.$router.push({ name: 'Detalle Pedido a Distribuidor', params:{id}});
      },

      eliminarPedido(id){
        this.eliminar_pedido_msg = this.$t('PEDIDO_eliminar_mensaje');
        this.eliminar_pedido = true;
        this.pedido_id = id;
      },

      onCloseEliminarConfirmation(confirm){

        if(confirm){
          this.deletePedido(this.pedido_id);
        }

        this.eliminar_pedido_msg = "";
        this.eliminar_pedido = false;
        this.pedido_id = undefined;
      },

      deletePedido(id){
        let payload = { }
        payload.idUsuario = this.idUsuario
        payload.id = id

        this.$store.dispatch("pedidosADistribuidores/eliminarPedido", payload)
        //this.$store.dispatch("pedidos/eliminarPedido", payload)
          .then(result => {
            if (result.CodigoResultado != 0)  mostrarMensajeInternacionalizado(
                result.CodigoResultado,
                result.DescripcionResultado
              );
            else showSuccess(this.$t("GENERAL_success"));
          })
          .finally(() => (this.getPedidos()));

      },

      clearDesdeHasta(){
        this.filtros.from = null;
        this.filtros.to = null;
      }
    },
    
    mounted() 
    {
      //Scroll para Android
       document.body.scrollTop = 0;
       //Scroll para IOS
       document.documentElement.scrollTop = 0;
      // verifico si se pas� un n�mero de pedido como par�metro
      if(this.$route.params.numeroPedido !== undefined)
      {
        this.filtros.numero = this.$route.params.numeroPedido;
        this.filtros.instancia = '4';
      }

      // verifico si se deben mantener los �ltimos filtros aplicados
      if (this.$route.params.keepFilter === true)
        this.filtros = { ...this.ultimoFiltroAplicado };

      // busco los pedidos
      this.getPedidos();
    }
    }
</script>

<style scoped>
.greyLabel {
  color: #6B6B6B;
  font-weight: normal;
}


.blackLabel {
  font-size: 14px;
  color: black;
  text-align: left;
  font-weight: bold;
}

.label {
  text-align: left;
  margin-bottom: 4px;
  font-size: 14px;
}

.seleccionador {
    width: 100%;
    padding: 0;
}

.btn-nuevo {
  padding-right:0%;
  text-align:right;
}
.el-card {
  height: 100%;
}
.cardBody {
  padding-left: 25px;
}

.container {
  display: flex;
  min-height: 500px !important;
  width:  100% !important;
}

.pagination_container {
  text-align: right;
  padding-right:0px;
}

.container_col_1 .el-collapse,
.container_col_1 .el-collapse.el-collapse-icon-position-right {
  width: 100%;
}

@media (max-width: 900px) {
  .busqueda {
  font-size: 10px;
  }
}

@media (max-width: 600px) {
  .container {
    flex-direction: column;
  }
  .container_col_1 {
    flex: 0 0 100% !important;
    width:100% !important;
    max-width:100% !important;
  }
  .container_col_2 {
    flex: 0 0 100% !important;
    width:100% !important;
    max-width:100% !important;
    margin-top:20px;
  }
  .busqueda {
  font-size: 14px;
  }

  .card_list {
    grid-template-columns: 1fr;
  }
}

.card {
  width: 100%;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.10);
  justify-self: center;
}

.card_list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  grid-gap: 1rem;
}
.card_list_item {
  position: relative;
}

.title {
  font-size: 18px;
  font-weight: bold;
  text-align: left;
  color: var(--main-color);
}
.sub-title {
  font-size: 18px;
  font-weight: bold;
  text-align: left;
  color: #999;
}
.filters {
  display: flex;
  flex-direction: column;
}
.filters_item {
  flex: 1;
  margin-bottom: 10px;
}


.clearFilters {
  color: #5aabc6;
  font-size: 14px;
  text-align: left;
  margin-top: 10px;
  cursor: pointer;
}

.fade-enter-active {
  transition: opacity 0.5s;
}
.fade-leave-active {
  transition: opacity 0.1s;   
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.soonToExpire {
  font-size: 14px;
  color: #2e2e2e;
  font-weight: bold;
  text-align: left;
  margin-top: 40px;
}
.el-radio-group {
  display: flex;
  flex-direction: column;
  text-align: left;
  margin-top: 14px;
}
.el-radio {
  line-height: 2;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}

.loader {
  margin-top: 25%;
  color: #999;
}
.ordena{
  text-align: right;
  margin-bottom: 20px;
}

.SinConfirmar{
  color: rgba(0, 0, 0, 0.644);
  font-size: 12px;
  margin-top: 0px;
  margin-bottom: 10px;
}
</style>

<style>
.ordenar .el-input__inner{
  border: none;
  width: 70%;
}
.el-icon-arrow-up:before{
  color:#409EFF;
  font-weight: bold;
}
.blackLabel {
  font-size: 14px;
  color: black;
  text-align: left;
  font-weight: bold;
}
.greyLabel {
  font-size: 14px;
  color: #6b6b6b;
  text-align: left;
  font-weight: normal;
}

</style>
